// Current-theme copy of the New Edge assets/ne-help.js (2 Nov 2026); keep the two in step.
// New Edge Help (sections/ne-help.liquid). Ported from BS - Website/site/help.js (2026-10-19). Until the concierge app
// ships, a question goes to Gorgias chat (the live app embed); without chat it opens the help centre. When the
// concierge embed sets window.bsConcierge, it is mounted in [data-ne-concierge] and every question goes to it instead.
(() => {
  const chat = (q) => {
    const g = window.GorgiasChat;
    if (!g) return false;
    const go = () => {
      try {
        g.open?.();
        if (q && typeof g.sendMessage === 'function') g.sendMessage(q);
      } catch { /* chat failed to open: the help centre link still works */ }
    };
    if (typeof g.init === 'function') g.init().then(go).catch(go); else go();
    return true;
  };

  const init = (root) => {
    if (root.dataset.neReady) return;
    root.dataset.neReady = '1';
    const centre = root.dataset.centre;
    const log = root.querySelector('[data-ne-concierge]');
    const form = root.querySelector('[data-ne-composer]');
    const input = form?.querySelector('input');
    const concierge = () => window.bsConcierge;
    let mounted = false;
    const mount = () => {
      const c = concierge();
      if (!c || mounted || typeof c.mount !== 'function') return !!c;
      c.mount(log);
      mounted = true;
      root.classList.add('has-concierge');
      // The floating concierge steps aside: this page is the concierge.
      document.documentElement.classList.add('ne-help-page');
      return true;
    };
    const ask = (q) => {
      q = (q || '').trim();
      if (!q) return;
      if (mount() && typeof concierge().ask === 'function') { concierge().ask(q); root.classList.add('is-talking'); return; }
      if (!chat(q)) window.open(centre, '_blank', 'noopener');
    };

    // ?q=<question> (footer links like Shipping) is asked once the concierge is here. It usually loads after this
    // script, so the question waits for 'bs:concierge-ready' instead of sitting in the box (found live, 2 Nov 2026).
    let pending = new URLSearchParams(location.search).get('q');
    const askPending = () => {
      if (!pending || !concierge()) return;
      const q = pending;
      pending = null;
      if (input) input.value = '';
      ask(q);
    };
    mount();
    document.addEventListener('bs:concierge-ready', () => { mount(); askPending(); });

    form?.addEventListener('submit', (e) => { e.preventDefault(); const q = input.value; input.value = ''; ask(q); });
    root.addEventListener('click', (e) => {
      const b = e.target.closest('[data-ne-chat]');
      if (b) { e.preventDefault(); const q = b.dataset.neAsk || ''; if (mount() && q) ask(q); else if (!chat(q)) window.open(centre, '_blank', 'noopener'); return; }
      // Answer pills follow their help-centre link, unless the concierge is here to answer in the page.
      const a = e.target.closest('a[data-ne-ask]');
      if (a && concierge()) { e.preventDefault(); ask(a.dataset.neAsk); }
    });

    if (pending && input) input.value = pending;
    askPending();
  };
  const run = () => document.querySelectorAll('[data-ne-help]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
